/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../services/GetEntityIdentifiers');
var ConSerIndividualNewView = require('../views/ConSerIndividualNewView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);

  GetEntityIdentifiers(entityId)
    .done(function(entity) {
      NavUtils.navigate('conser/entity/' + entityId + '/new-individual');
      Scaffold.content.show(
        new ConSerIndividualNewView({
          model: new Backbone.Model({
            entityId: entityId,
            entityName: entity.entityName
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
